/**
 * Route for `link-test`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { LinkTestPage } from "../features/link-test/LinkTestPage";

export const linkTestRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/link-test",
	component: LinkTestPage,
});

export default linkTestRoute;
